import { ReactNode } from 'react'

import { ComparatorTrigger } from './ComparatorTrigger'
import {
  PopoverCombobox,
  PopoverComboboxBoxProps,
} from '../Menu/PopoverCombobox'

export const ComparatorInput = <T extends string | number>({
  children,
  design = 'bold',
  singleSelect,
  ...props
}: Omit<PopoverComboboxBoxProps<T>, 'trigger' | 'type'> & {
  children: ReactNode
  design?: 'bold' | 'light'
  singleSelect?: boolean
}) => {
  return (
    <PopoverCombobox<T>
      trigger={
        <ComparatorTrigger design={design}>{children}</ComparatorTrigger>
      }
      type={singleSelect ? 'singleSelect' : 'multiSelect'}
      {...props}
    />
  )
}
